import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'

Vue.use(VueRouter)

let globalRoutes = [
  {path: '/', redirect: '/Home'},
  {path: '/Home', component: () => import('@/eiuov-page/Home.vue')},
  {path: '/Login', component: () => import('@/eiuov-page/Login.vue')},
  {path: '/Video', component: () => import('@/eiuov-page/Video.vue')},
  {path: '/MemberInfo', component: () => import('@/eiuov-page/MemberInfo.vue')},
  {path: '/test2', component: () => import('@/test/Test.vue')},
  {path: '/WorksDetail', component: () => import('@/eiuov-page/WorksDetail.vue')},
  {path: '/PersonDetail', component: () => import('@/eiuov-page/PersonDetail.vue')},
  {path: '/ArticleDetail', component: () => import('@/eiuov-page/ArticleDetail.vue')},
  {path: '/WorksList', component: () => import('@/eiuov-page/WorksList.vue')},
]


const router = new VueRouter({
  routes: globalRoutes,
  mode: 'history',
  isAddDynamicMenuRoutes: false
})

/*  路由导航守卫控制访问权限 */
router.beforeEach((to, from, next) => {
  NProgress.start();
  console.log(`%c====================== 路由导航守卫控制访问 ======================>`, 'color:blue')
  // if (to.path !== '/login' && !router.options.isAddDynamicMenuRoutes) {
  //   console.log(`%c====================== 获取路由 ===> 请求 ======================>`, 'color:blue')
  //   queryFrontPathAction({}).then((res) => {
  //     if (isFailure(res)) {
  //       console.log(`请求菜单列表和权限失败，跳转至登录页！！`, 'color:red')
  //     } else {
  //       addRouteToRouter(res.data.list)
  //       sessionStorage.setItem('routeList', JSON.stringify(res.data.list || '[]'))
  //       router.options.isAddDynamicMenuRoutes=true
  //       console.log(`%c====================== 获取路由 ===> 成功 ======================>`, 'color:green')
  //       //next({...to, replace: true});
  //     }
  //   })
  // }
  next();
  NProgress.done();
})

/*function addRouteToRouter(list) {
  let homeRoutes = []
  for (let i = 0; i < list.length; i++) {
    let item = list[i]
    let route = {
      path: '/' + item.path,
      component: () => import(`../views/${item.groupName}/${item.componentName}`)
    }
    homeRoutes.push(route)
  }
  homeRoutes.push(home)
  router.addRoutes(homeRoutes)
}*/

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
